<igx-grid #gridProveedores [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdProveedor'" (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateProveedor($event)" (rowEdit)="validarProveedor($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()"
  [igxGridState]="optionsGridLocal" (columnInit)="onColumnInit($event)" [moving]="true" (keydown)="customKeydown($event)" paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)"
          (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event);" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Proveedor" header="{{ 'GRIDS.PROVEEDOR.COL_PROVEEDOR' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #proveedorHeaderTemplate let-column>
      <div title="{{ 'GRIDS.PROVEEDOR.COL_PROVEEDOR' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #proveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Proveedor" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  @if (false) {
    <igx-column field="IdCiudad" [disableHiding]="true" />
  }
  <igx-column field="DescripcionCiudad" header="{{ 'GRIDS.PROVEEDOR.COL_CIUDAD' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxCellEditor #descripcionCiudadEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #inputDescripcionCiudad igxInput name="DescripcionCiudad" type="text" [(ngModel)]="cell.editValue" uppercase [readOnly]="true"
               (keydown)="stopPropagationPegado($event)"/>
        <igx-suffix>
          <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained" (buttonClick)="onOpen(inputDescripcionCiudad, cell.row.data)">
            <igx-icon>search</igx-icon>
          </button>
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="RazonSocial" header="{{ 'GRIDS.PROVEEDOR.COL_RS' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true" >
    <ng-template igxHeader #razonSocialHeaderTemplate let-column>
      <div title="{{ 'GRIDS.PROVEEDOR.COL_RS' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #razonSocialEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="RazonSocial" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="122"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="RfcProveedor" header="RFC" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #rfcProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="RfcProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="15"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="DireccionProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_DIRECCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #direccionProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DireccionProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="ColoniaProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_COLONIA' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #coloniaProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="ColoniaProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CodigoPostalProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_CP' | translate}}" [dataType]="'string'" width="140px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #cpProveedorditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CodigoPostalProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="6"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="TelefonoProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_TELEFONO' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #telefonoProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="TelefonoProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="FaxProveedor" header="Fax" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #faxProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="FaxProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="MailProveedor" header="Mail" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #mailProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="MailProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="100"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="ContactoProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_CONTACTO' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #contactoProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="ContactoProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="ObservacionesProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_OBS' | translate}}" [dataType]="'string'" width="160px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #observacionesProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="ObservacionesProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CelularProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_CELULAR' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #celularProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CelularProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="PaginaWebProveedor" header="{{ 'GRIDS.PROVEEDOR.COL_PAGINA' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #paginaWebProveedorEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="PaginaWebProveedor" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="ProveedorDefault" header="{{ 'GRIDS.PROVEEDOR.COL_PROV_DEFAULT' | translate}}" [dataType]="'boolean'" width="180px" [sortable]="true" [resizable]="false"  />
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
